import { StyleSheet } from 'react-native';
import { appTheme } from '@/config/colors';

export default StyleSheet.create({
  title: {
    fontSize: 22,
    fontWeight: '500',
    color: '#3a3a3a',
    marginBottom: 20,
  },
  subTitle: {
    color: '#3a3a3a',
    marginBottom: 10,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 5,
    marginBottom: 10,
    flexWrap: 'wrap',
  },
  radio: {
    backgroundColor: '#ffff',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    borderRadius: 2,
    minWidth: 50,
    padding: 10,
    marginVertical: 2,
    marginHorizontal: 4,
  },
  radioText: {
    color: '#3a3a3a',
    textAlign: 'center',
  },
  radioActive: {
    backgroundColor: appTheme.primary,
  },
  radioActiveText: {
    color: '#ffff',
  },
});
